/*
    Custom JavaScript for Carpetivity
    North-coast products: show "Pre-order" only for variants with inventory_quantity <= 0
                          show "Add to cart" for variants with inventory_quantity > 0
*/
document.addEventListener('DOMContentLoaded', () => {

    function isVariantPreorder(variantId) {
        if (!window.__carpetivity_is_north_coast) return false
        const inv = window.__carpetivity_variant_inventory &&
                    window.__carpetivity_variant_inventory[String(variantId)]
        if (!inv) return false
        if (inv.inventory_management !== 'shopify') return false
        return inv.inventory_quantity <= 0
    }

    function getActiveVariantId() {
        const urlParams = new URLSearchParams(window.location.search)
        const fromUrl = urlParams.get('variant')
        if (fromUrl) return fromUrl
        const hiddenInput = document.querySelector('.shopify-product-form input[name="id"]')
        return hiddenInput ? hiddenInput.value : null
    }

    const updateNorthCoastButtons = (variantId) => {
        if (!window.__carpetivity_is_north_coast) return

        variantId = variantId ? String(variantId) : getActiveVariantId()
        if (!variantId) return

        const preorder = isVariantPreorder(variantId)

        document.querySelectorAll('.shopify-product-form').forEach(form => {
            const btn = form.querySelector('.btn-atc')
            const preNotice = form.querySelector('.preorder-notice')
            const stockNotice = form.querySelector('.instock-notice')

            if (!btn) return

            btn.disabled = false
            btn.removeAttribute('disabled')
            btn.removeAttribute('aria-disabled')
            btn.style.display = ''

            if (preorder) {
                btn.innerHTML = btn.dataset.textPreorderBuy || 'Pre-order'
                if (preNotice) preNotice.hidden = false
                if (stockNotice) stockNotice.hidden = true
            } else {
                btn.innerHTML = btn.dataset.textAddToCart ||
                                (window.theme && window.theme.product && window.theme.product.addToCart) ||
                                'Add to cart'
                if (preNotice) preNotice.hidden = true
                if (stockNotice) stockNotice.hidden = false
            }
        })
    }

    // Set correct state on page load
    updateNorthCoastButtons()

    // Update when the variant switcher fires its event (passes the selected variant in detail)
    window.addEventListener('variantChange.ecomify.product', (event) => {
        const variantId = event.detail ? String(event.detail.id) : null
        setTimeout(() => updateNorthCoastButtons(variantId), 50)
        setTimeout(() => updateNorthCoastButtons(variantId), 300)
        setTimeout(() => updateNorthCoastButtons(variantId), 800)
    })
})
